import { Pipe, PipeTransform } from '@angular/core';
import type { Delta } from 'quill/core';

export function hasDisplayableQuillContent(
  delta: Delta | null | undefined,
): boolean {
  return (
    delta?.ops?.some((op) =>
      typeof op.insert === 'string'
        ? op.insert.trim() !== ''
        : op.insert != null,
    ) ?? false
  );
}

@Pipe({
  name: 'hasDisplayableQuillContent',
})
export class HasDisplayableQuillContentPipe implements PipeTransform {
  transform(delta: Delta | null | undefined): boolean {
    return hasDisplayableQuillContent(delta);
  }
}
